import { NoteGrayIcon } from "../../../utils/customIcons";
import { Note } from "../../../types/modulesInterfaces";
import NoteTextViewer from "./NoteTextViewer";
import NoteMenu from "./NoteMenu";
import TranslatableText from "../../translations/TranslatableText";
import { useIconSize } from "@app/hooks";

interface NoteViewerProps {
    notes: Note;
    canMutateNote: boolean;
    onEdit: () => void;
    onDelete: () => void;
}

const NoteDisplayBlock = ({ children }: { children: React.ReactNode }) => {
    const iconSize = useIconSize(16);
    return (
        <div className="d-flex justify-content-between pb-2">
            <div className="d-flex align-items-end" style={{ paddingLeft: "3px" }}>
                <NoteGrayIcon size={iconSize} />
                <strong className="ff-bold fs-13 ps-1 text-darker-gray">
                    <TranslatableText translationKey="module.project_note" />
                </strong>
            </div>
            {children}
        </div>
    );
};

export const NoteViewer = ({ notes, canMutateNote, onEdit, onDelete }: NoteViewerProps) => {
    return (
        <>
            <NoteDisplayBlock>
                {canMutateNote && (
                    <div className="pos-relative">
                        <NoteMenu onEdit={onEdit} onDelete={onDelete} />
                    </div>
                )}
            </NoteDisplayBlock>
            <div className="note-text-editor-container">
                <span className="fs-12 text-darker-gray">
                    <NoteTextViewer note={notes.content} />
                </span>
            </div>
        </>
    );
}; 